export default __webpack_public_path__ + "static/media/poweredByIntertek-logo.5277692b.svg";